import React from "react";
import Grid from '@mui/material/Grid2';
import LocalStorageService from '../../services/localStorage';

import {
    Box,
} from '@mui/material';
import './Footer.css'

const localStorageService = LocalStorageService.getService();

const substituteTokens = (text, year) =>
    (text || '')
        .replaceAll('{{CURRENT_YEAR}}', String(year))
        .replaceAll('{{CURRENT_YEAR_MINUS_1}}', String(year - 1));

const Footer = () => {

    const codingRef = React.useRef();
    const footerRef = React.useRef();

    const brandingInfo = localStorageService.getBrandingInfo();

    const year = new Date().getFullYear();

    React.useEffect(() => {
        if (!brandingInfo) {
            return;
        }

        const branding = JSON.parse(brandingInfo);

        if (codingRef.current) {
            codingRef.current.innerHTML = substituteTokens(branding.coding_notice, year);
        }
        if (footerRef.current) {
            footerRef.current.innerHTML = substituteTokens(branding.footer, year);
        }
    }, [brandingInfo, year]);

    return (
        <Box component="section" className="footerBox">
            <Grid container className="container" style={{padding:'16px'}}>
                <Grid item size={12} >
                    <p ref={codingRef} style={{marginBottom: '5px', padding: '0 9%', textAlign: 'center'}}></p>
                    <p ref={footerRef} style={{textAlign: 'center'}}></p>
                </Grid>
            </Grid>
        </Box>
    )
}

export default Footer;
